import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67e04222&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=67e04222&scoped=true&lang=css&"
import style1 from "./mobile.scss?vue&type=style&index=1&id=67e04222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e04222",
  null
  
)

export default component.exports